
import BookingSdnBanner from "@/app/ui/components/booking-sdn-banner/index.vue";
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options, prop } from "vue-class-component";
import {
  CustomProcessEditAddressForm,
  RequestPatchReverseDestination
} from "@/domain/entities/CustomProcess";
import { CustomProcessController } from "@/app/ui/controllers/CustomProcessController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PatchReverseDestinationApiRequest } from "@/data/payload/api/CustomProcessApiRequest";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PartnerController } from "@/app/ui/controllers/PartnerController";
import { ClientPartnerOptions } from "@/domain/entities/CnManifest";
import debounce from "lodash/debounce";
import {
  ErrorBookingV3,
  BookingV3,
  PosterProduct,
  DocInternationalModelValueType,
  CommodityCIPL,
  CommodityBookingV3,
  ConfigValidationForm
} from "@/domain/entities/CreateBookingV3";
import CommoditySection from "./components/comodity/index.vue";
import DeliveryType from "./components/delivery-type/product/index.vue";
import DetailSender from "./components/detail-sender/index.vue";
import DetailReceiver from "./components/detail-receiver/index.vue";
import DocInternational from "./components/booking-extra/doc-international/index.vue";
import CheckTariffV2 from "@/app/ui/views/shipment/booking/create-booking-v3/components/footer/components/check-tariff.vue";
import WeightCost from "@/app/ui/views/shipment/booking/create-booking-v3/components/footer/components/weight-cost.vue";
import {
  EstimationPrice,
  PayloadPosterProduct,
  ComodityProductPoster,
  PiecesPosterProduct
} from "@/domain/entities/Booking";
import {
  SttAdjustmentRule,
  SttPieces
} from "@/domain/entities/ShipmentBooking";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import {
  GetEstimationPrice,
  SubmitPosterProductApiRequest
} from "@/data/payload/api/BookingRequest";
import { DistrictData } from "@/domain/entities/Location";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { OptionsClass } from "@/domain/entities/MainApp";
import { ClientData } from "@/domain/entities/BulkBooking";
import { SttFtzCipl } from "@/data/payload/api/BookingRequest";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { Commodity } from "@/domain/entities/Commodity";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { ProductConfigurationRuleRequestParams } from "@/data/payload/api/ProductApiRequest";
import { PartnerDetail } from "@/domain/entities/Partner";
import {
  formatInputMoney,
  formatInputMoneyWithDecimal
} from "@/app/infrastructures/misc/Utils";
import { parseMultiFieldZodError, parseZodError } from "./utils";
import {
  senderAddressSchema,
  senderPhoneSchema,
  senderReceiverSchema,
  senderSchema
} from "./components/detail-sender/validation";
import { commoditySchema } from "./components/comodity/validation-commodity";
import {
  receiverSchema,
  receiverPhoneSchema,
  receiverAddressSchema,
  receiverDestinationCitySchema,
  receiverPostalCodeSchema
} from "./components/detail-receiver/validation";
import {
  emailSchema,
  goodsPriceSchema,
  idNumberSchema,
  imageSchema,
  itemDetailSchema,
  quantitySchema,
  taxNumberSchema
} from "./components/booking-extra/doc-international/validation";
import { codePhoneCountry } from "../booking-utils";
import i18n from "@/i18n";
import { resolveApiBilingualMessage } from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { FlagsFeatureShipmentC1 } from "@/feature-flags/flags-shipment-c1";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { createFocusTrap } from "focus-trap";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";

interface ResponseData {
  success: boolean;
  response: ResponsePayloadV2;
}

class Props {
  defaultStt = prop<CustomProcessEditAddressForm>({
    default: new CustomProcessEditAddressForm()
  });
  rtsOrCnx = prop<boolean>({
    default: false
  });
  posNameForInternal = prop<string>({
    default: "",
    type: String
  });
  posIDForInternal = prop<string>({
    default: "",
    type: String
  });
  posField = prop<boolean>({
    default: false
  });
  isCustomProcess = prop<boolean>({
    default: false,
    type: Boolean
  });
  isRTS = prop<boolean>({
    default: false
  });
  isREROUTE = prop<boolean>({
    default: false
  });
}

@Options({
  emits: ["close", "onSubmit"],
  components: {
    BookingSdnBanner,
    CommoditySection,
    DeliveryType,
    DetailSender,
    DetailReceiver,
    DocInternational,
    CheckTariffV2,
    WeightCost
  },
  watch: {
    upsellingData: {
      handler(products: PosterProduct[]) {
        if (!this.productNameTemp) return;
        if (!products.length) return;
        const isSelectedProductDisabled =
          products.findIndex(
            (product) =>
              product.productType.toLowerCase() ===
              this.productNameTemp.toLowerCase()
          ) === -1;
        if (isSelectedProductDisabled) this.formBooking.productName = "";
        else this.formBooking.productName = this.productNameTemp;
      },
      deep: true
    },
    upsellingPayload: {
      handler() {
        this.getUpsellingDataDebounced();
      },
      deep: true
    },
    estimationPricePayload: {
      handler() {
        this.getEstimationPriceDebounce();
      },
      deep: true
    },
    "formBooking.productName": {
      handler(val) {
        if (!val) return;
        this.productNameTemp = val;
      },
      deep: true,
      immediate: true
    },
    "destinationCity.isCod": {
      handler(val) {
        if (this.isREROUTE && this.form.sttIsCod.toLowerCase() === "yes") {
          if (val === "no") {
            this.error.destinationCity = "Distrik tidak tersedia COD/DFOD";
          } else {
            this.error.destinationCity = "";
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
})
class ModalBookingReverseJourney extends Vue.with(Props) {
  form: CustomProcessEditAddressForm = new CustomProcessEditAddressForm();
  selectedPartnerPos: any = "";
  isLoadingPartners = false;
  partnersData: ClientPartnerOptions[] = [];
  currentIndex = 0;
  error = new ErrorBookingV3();
  formBooking = new BookingV3();
  loadingUpsellingData = false;
  upsellingData: any[] = [];
  upsellingDataTemp: any[] = [];
  productNameTemp = "";
  estimationPriceData = new EstimationPrice();
  configurationRules: ProductConfigurationRule[] = [];
  loadingEstimationPrice = false;
  errorEstimationPrice = false;
  isLoadingEstimation = false;
  isErrorUpselling = false;
  commonProducts = [];
  clientOnlyProducts = ["ONEPACK"];

  get countryCode() {
    return AccountController.accountData.countryCode.toUpperCase()
  }

  get listProducts() {
    this.commonProducts = this.countryCode === 'MY' ?
    FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .countries.MY.reverseJourney :
    FlagsPermissionBookingV3.config_upselling_product_list.getValue().reverseJourney;
    console.log(this.commonProducts, 'this.commonProducts')
    let list =
      this.formType === "client"
        ? [
            ...this.commonProducts,
            ...(this.countryCode === "ID" ? this.clientOnlyProducts : [])
          ].filter((product) => product !== "VIPPACK")
        : [...this.commonProducts];

    if (this.defaultStt.shipmentId) {
      list = list.filter(
        (product) => !["ONEPACK", "VIPPACK"].includes(product)
      );
    }

    if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled()) {
      list = list.filter((product) => product !== "BIGPACKFAST");
    }

    if (!list.includes(this.defaultStt.product)) {
      list.push(this.defaultStt.product);
    }

    return list;
  }
  disableSelectPartnerField = false;
  errorRouteNotFound = false;

  created() {
    // note pengirim:
    // TODO: NON-EDITABLE!!!
    // TODO: jika RTS, CNX: ambil data pengirim dari user console
    // TODO: jika Reroute: ambil data pengirim dari stt origins ender
    //
    // note penerima
    // TODO: jika RTS, CNX: ambil data penerima dari stt origin sender
    // TODO: jiika Reroute: ambil data penerima dari stt origin penerima
    //
    // note komoditas
    // TODO: ambil dari komoditas stt origin
    //
    // note FTZ
    // TODO: tidak ada perubahan validasi, sama seperti di create booking
    //
    // note upselling
    // TODO: sama seperti di create booking, tetapi tidak ada interpack
    //
    // note footer
    // TODO: sama seperti di masing-masing booking retail dan client
    this.form = JSON.parse(JSON.stringify(this.defaultStt));
    const receiverPhone = Array.isArray(this.form.consigneePhone)
      ? this.form.consigneePhone[0].value
      : this.form.consigneePhone;
    this.formBooking = new BookingV3({
      sttManual: this.form.sttNumber,
      sttShipmentId: this.form.shipmentId,
      sender: this.form.senderName,
      phoneCodeSender: this.form.sttSenderPhoneCode,
      phoneSender: this.form.senderPhone,
      addressSender: this.form.senderAddress,
      receiver: this.form.consigneeName,
      phoneCodeReceiver: this.form.sttRecipientPhoneCode,
      phoneReceiver: receiverPhone,
      addressReceiver: this.form.consigneeAddress,
      destinationCity: this.form.destinationCity,
      postalCodeDestination: this.form.destinationCity.destinationZipCode,
      addressReceiverType: new OptionsClass({
        name: this.form.addressType,
        value: this.form.addressType
      }),
      commodity: new OptionsClass({
        name: this.form.commodity.commodity_name,
        code: this.form.commodity.commodity_code
      }),
      ftzForm: this.ftzForm,
      productName: this.form.product,
      pieces: this.sttPieces,
      isCOD: this.form.sttIsCod === "yes",
      isDFOD: this.form.sttIsDfod,
      estimationPrice: this.form.sttGoodsEstimatePrice,
      clientName: new ClientData({
        isCOD: this.form.sttIsCod === "yes" ? true : false,
        isDO: this.form.sttIsDo,
        isFtz: this.form.isFtz
      })
    });
  }
  sdnReady = false;
  focusTrap: any = null;

  async mounted() {
    await this.fetchDetailPartner();
    this.getUpsellingData();
    this.getEstimationPriceDebounce();
    this.fetchConfigRule();
    const modal = (this.$refs["modal-booking-reverse"] as any)?.$el;
    this.focusTrap = createFocusTrap(modal, {
      allowOutsideClick: true,
      clickOutsideDeactivates: true,
      onDeactivate: () => {
        this.closeModal();
      }
    });
    this.focusTrap.activate();
  }

  unmounted() {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }

  async fetchConfigRule() {
    ProductController.fetchProductConfigurationRule(
      new ProductConfigurationRuleRequestParams()
    ).then((res) => {
      this.configurationRules = res.data;
    });
  }

  configDisabled = new SttAdjustmentRule({
    isRequired: true,
    rule: ConfigValidationForm.NON_EDITABLE
  });

  get formattedChargeableWeight(): any {
    return this.chargeableWeight;
  }

  get isCodRetail() {
    return (
      this.form.sttIsCod.toLowerCase() === "yes" &&
      this.form.statusStt === "RTS" &&
      (this.sttCodRetail || this.sttCodCaRetail)
    );
  }

  get sttCodRetail() {
    const sttNumber = this.form.rootReverseJourneySttNo || this.form.sttNumber;
    return !!(
      sttNumber.toLocaleLowerCase().match(/^11lp/gi) ||
      sttNumber.toLowerCase().match(/^10lp/gi)
    );
  }
  get sttCodCaRetail() {
    return !!this.form.shipmentId.match(/^ARA|^ARB/gi);
  }

  get shipmentC1SpecialCod() {
    return (
      this.form.shipmentId.startsWith(
        FlagsFeatureShipmentC1.feature_shipment_c1.getValue()
      ) &&
      this.form.sttIsCod.toLowerCase() === "yes" &&
      this.form.codHandling.toLowerCase() === "specialcod"
    );
  }

  get shipmentFavoritCodDfod() {
    return !!(
      this.form.shipmentId.match(/^AP|^AS/gi) &&
      (this.form.sttIsCod.toLowerCase() === "yes" || this.form.sttIsDfod) &&
      this.form.statusStt !== "REROUTE"
    );
  }

  get disabledDetailReceiver() {
    if (
      [
        this.isCodRetail,
        this.shipmentC1SpecialCod,
        this.shipmentFavoritCodDfod
      ].includes(true)
    ) {
      return new SttAdjustmentRule({
        isRequired: true,
        rule: ConfigValidationForm.NON_EDITABLE
      });
    } else {
      return new SttAdjustmentRule({
        isRequired: true,
        rule: ConfigValidationForm.EDITABLE
      });
    }
  }

  get isFromCustomStatus() {
    return this.$route.path === "/custom-status/update";
  }

  get formType() {
    return this.defaultStt.sttBookedForType === "client" ? "client" : "manual";
  }

  get isCustomerApps() {
    return this.defaultStt.sttBookedFor.toLowerCase() === "customer apps";
  }

  closeModal() {
    this.sdnReady = false;
    this.$emit("close", false);
  }

  refreshCheckTariff() {
    // refresh check tariff
    this.getEstimationPriceDebounce();
  }

  _customRound(fractionRule = 0.31, weightNumber = 0) {
    const fraction = weightNumber % 1;

    if (fraction >= fractionRule) {
      return Math.ceil(weightNumber);
    }

    return Math.floor(weightNumber);
  }

  setForm() {
    this.form = new CustomProcessEditAddressForm({
      ...this.form,
      sttNumber: this.formBooking.sttManual,
      shipmentId: this.formBooking.sttShipmentId,
      senderName: this.formBooking.sender,
      consigneeName: this.formBooking.receiver,
      senderAddress: this.formBooking.addressSender,
      consigneeAddress: this.formBooking.addressReceiver,
      senderPhone: this.formBooking.phoneSender,
      destinationCity: this.formBooking.destinationCity,
      consigneePhone: this.formBooking.phoneReceiver,
      sttIsInterpack: this.form.sttIsInterpack,
      addressType: this.formBooking.addressReceiverType.value,
      product: this.formBooking.productName,
      commodity: new Commodity({
        commodity_id: this.formBooking.commodity.id,
        commodity_name: this.formBooking.commodity.name,
        commodity_code: this.formBooking.commodity.code
      }),
      goodsStatus: this.formBooking.ftzForm.shipmentStatus.value || "ecommerce",
      taxNumber: this.formBooking.ftzForm.taxNumber,
      isFtz: this.form.isFtz,
      isFtzEditable: this.form.isFtzEditable,
      sttPiecePerPack: this.form.sttPiecePerPack,
      sttNextCommodity: this.form.sttNextCommodity,
      sttIsCod: this.form.sttIsCod,
      sttIsDfod: this.form.sttIsDfod,
      sttIsDo: this.form.sttIsDo,
      sttBookedBy: this.form.sttBookedBy,
      statusStt: this.form.statusStt,
      codHandling: this.form.codHandling,
      remarks: this.form.remarks,
      sttPieces: this.formBooking.pieces,
      sttFtzKtpImage: this.formBooking.ftzForm.imageIdUrl,
      sttFtzAttachFiles: [
        this.formBooking.ftzForm.imageBeforePackingUrl,
        this.formBooking.ftzForm.imageAfterPackingUrl
      ].filter(Boolean),
      sttFtzRecipientEmail: this.formBooking.ftzForm.email,
      sttFtzIdentityNumber: this.formBooking.ftzForm.idNumber,
      sttFtzTaxImage: this.formBooking.ftzForm.imageTaxUrl,
      sttFtzCipl: this.formBooking.ftzForm.listCommodityCIPL
        .filter((cipl) => cipl.name)
        .map((cipl: any) => ({
          quantity: Number(cipl.quantity.toString().replaceAll(".", "")),
          item_price: Number(cipl.goodsPrice.toString().replaceAll(".", "")),
          item_detail_en: cipl.commodity.nameEn || cipl.name,
          item_detail: cipl.commodity.nameId || cipl.name,
          commodity_hs_code: cipl.commodity.hsCode
        })) as any,
      sttTaxNumber: this.formBooking.ftzForm.taxNumber,
      sttSenderStatus: this.formBooking.ftzForm.shipmentStatus.value,
      sttGoodsStatus: this.formBooking.ftzForm.shipmentStatus.value,
      sttCommodityCode: this.formBooking.commodity.code,
      postalCode:
        typeof this.formBooking.postalCodeDestination === "string"
          ? this.formBooking.postalCodeDestination
          : this.formBooking.postalCodeDestination.name
    });
  }

  get destinationCity(): DistrictData {
    if (typeof this.formBooking.destinationCity === "string") {
      return new DistrictData();
    }
    return this.formBooking.destinationCity;
  }

  get postalCodeDestination() {
    return this.formBooking.postalCodeDestination instanceof DistrictData
      ? this.formBooking.postalCodeDestination
      : typeof this.formBooking.postalCodeDestination === "string"
      ? new DistrictData({ name: this.formBooking.postalCodeDestination })
      : new DistrictData();
  }

  get isFormValid() {
    const formValidation = {
      isSenderNameValid: !parseZodError(senderSchema, this.formBooking.sender),
      isSenderPhoneValid: this.configDisabled.rule === ConfigValidationForm.NON_EDITABLE ? true : !!this.formBooking.phoneSender.replace("+", ""),
      isSenderAddressValid: !parseZodError(
        senderAddressSchema,
        this.formBooking.addressSender
      ),
      isSenderRecipientAddressValid: !parseMultiFieldZodError(
        senderReceiverSchema,
        {
          addressSender: this.formBooking.addressSender,
          addressReceiver: this.formBooking.addressReceiver
        },
        "addressSender"
      ),
      isRecipientNameValid: !parseZodError(
        receiverSchema,
        this.formBooking.receiver
      ),
      isRecipientPhoneValid: this.disabledDetailReceiver.rule === ConfigValidationForm.NON_EDITABLE ? true : !!this.formBooking.phoneReceiver.replace("+", ""),
      isRecipientAddressValid: !parseZodError(
        receiverAddressSchema,
        this.formBooking.addressReceiver
      ),
      isRecipientDestinationValid: !parseZodError(
        receiverDestinationCitySchema,
        {
          destination: this.destinationCity.name,
          embargo: this.formBooking.destinationIsEmbargo,
          unavailable: this.formBooking.destinationIsUnavailable
        }
      ),
      isRecipientPostalCodeValid: !parseZodError(
        receiverPostalCodeSchema,
        this.postalCodeDestination.name
      ),
      isCommodityValid: !parseZodError(
        commoditySchema,
        this.formBooking.commodity
      ),
      isFtzValid: this.form.isFtz ? this.isFtzFormValid : true,
      isProductNameValid: !!this.formBooking.productName,
      isSelectedPartnerPosValue: this.isRtsOrCnx
        ? !!this.selectedPartnerPos?.id
        : true,
      isNotEmbargo: !this.isErrorEmbargoDestination,
      isDestinationEligibleCOD: this.isDestinationEligibleCOD
    };

    return !Object.values(formValidation).includes(false);
  }

  get isDestinationEligibleCOD() {
    if (!this.isREROUTE) return true;
    return this.form.sttIsCod.toLowerCase() === "yes"
      ? this.destinationCity.isCod.toLowerCase() === "yes"
      : true;
  }

  get isFtzFormValid() {
    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(false, true, this.formBooking.ftzForm.email),
        this.formBooking.ftzForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(false),
        this.formBooking.ftzForm.idNumber
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(false, true, this.formBooking.ftzForm.taxNumber),
        this.formBooking.ftzForm.taxNumber
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(false, this.formBooking.ftzForm.imageIdUrl),
        this.formBooking.ftzForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(false, this.formBooking.ftzForm.imageTaxUrl),
        this.formBooking.ftzForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(false, this.formBooking.ftzForm.imageBeforePackingUrl),
        this.formBooking.ftzForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(false, this.formBooking.ftzForm.imageAfterPackingUrl),
        this.formBooking.ftzForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL()
    };

    return !Object.values(validation).includes(false);
  }

  get isFtzAccount() {
    return (
      this.formBooking.clientName.isFtz ||
      AccountController.accountData.account_location?.city_free_trade_zone ===
        "yes"
    );
  }

  validateCIPL() {
    const validations: boolean[] = [];
    const ciplList = this.formBooking.ftzForm.listCommodityCIPL;

    ciplList.forEach((cipl) => {
      validations.push(!parseZodError(itemDetailSchema, cipl.name));
      validations.push(!parseZodError(quantitySchema, cipl.quantity));
      validations.push(!parseZodError(goodsPriceSchema, cipl.goodsPrice));
    });

    return !Object.values(validations).includes(false);
  }

  get isRtsOrCnx() {
    return this.rtsOrCnx;
  }

  calculateEligibleLowVolume(currentRule?: ProductConfigurationRule) {
    const isShipmentEligible =
      !this.formBooking.shipmentId ||
      !!currentRule?.prefixShipment
        .split(",")
        .some((prefix) => this.formBooking.shipmentId.startsWith(prefix));
    const lowVolume = currentRule?.lowVolume || 0;
    if (
      !!lowVolume &&
      this.totalVolumeWeight <= lowVolume &&
      isShipmentEligible
    ) {
      return this.totalGrossWeight;
    }
  }

  get estimationVolumeWeight() {
    return this.estimationPriceData.volumeWeight;
  }

  get chargeableWeight() {
    return this.estimationPriceData.chargeableWeight;
  }

  get totalVolumeWeight() {
    return this.formBooking.pieces.reduce(
      (prev, curr: any) => prev + +curr.volumeWeight,
      0
    );
  }

  get totalGrossWeight() {
    return this.formBooking.pieces.reduce(
      (prev, curr: any) => prev + +curr.grossWeight,
      0
    );
  }

  get accountData() {
    return AccountController.accountData;
  }

  get isUserHasPartnerPos() {
    return !!this.accountData.account_type_detail.partnerIdSttReturn;
  }

  get parentId() {
    return AccountController.accountData.account_type_detail.id;
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  get pieces() {
    return this.form.sttPieces?.map(
      (key: any) =>
        new PiecesPosterProduct({
          pieceLength: key.dimension.length,
          pieceWidth: key.dimension.width,
          pieceHeight: key.dimension.height,
          pieceGrossWeight: key.grossWeight
        })
    ) as any;
  }

  get goodsPrice(): number {
    return Number(this.formBooking.estimationPrice?.replace(/\./g, ""));
  }

  get upsellingPayload() {
    return new SubmitPosterProductApiRequest({
      payload: new PayloadPosterProduct({
        originId: this.districtDetail.code as any,
        destinationId: this.destinationCity.code,
        commodity:
          typeof this.formBooking.commodity === "object"
            ? {
                data: new ComodityProductPoster({
                  commodityId: +(this.formBooking.commodity.id as number),
                  commodityName: this.formBooking.commodity?.name,
                  commodityCode: this.formBooking.commodity?.code
                })
              }
            : { data: new ComodityProductPoster() },
        commodityId:
          typeof this.formBooking.commodity === "object"
            ? (this.formBooking.commodity.id as number)
            : 499,
        isCod: this.formBooking.serviceType === "cod",
        isDfod: this.formBooking.serviceType === "dfod",
        codAmount: Math.max(
          ["cod", "dfod"].includes(this.formBooking.serviceType) ? 1 : 0,
          Number(
            this.formBooking.codAmount
              ? this.formBooking.codAmount?.replace(/\./g, "")
              : this.goodsPrice
          )
        ),
        goodsPrice: this.goodsPrice,
        pieces: this.formBooking.pieces?.map(
          (piece: any) =>
            new PiecesPosterProduct({
              pieceWidth: piece.dimension.width,
              pieceLength: piece.dimension.length,
              pieceHeight: piece.dimension.height,
              pieceGrossWeight: Number(
                String(piece.grossWeight).replace(",", ".")
              )
            })
        ),
        accountType: "pos",
        accountRefId: 0,
        isBookingPuposes: false
      })
    });
  }

  async getUpsellingData() {
    try {
      this.upsellingData = [];
      this.loadingUpsellingData = true;
      this.isErrorUpselling = false;
      this.errorRouteNotFound = false;
      const resp = await BookingController.postToGetPosterProduct(
        this.upsellingPayload
      );
      this.upsellingData = resp.map(
        (product: any) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla.replace(" Hari", ""),
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            grossWeight: product.gross_weight,
            volumeWeight: product.volume_weight,
            chargeableWeight: product.chargeable_weight,
            shippingCost: product.shipping_cost
          })
      );
      this.upsellingDataTemp = this.upsellingData;
      const isSelectedProductExist = !!this.upsellingData.find(
        (product) =>
          product.productType.toLowerCase() ===
          this.formBooking.productName.toLowerCase()
      );
      if (!isSelectedProductExist) {
        this.upsellingData.push(
          new PosterProduct({
            productType: this.formBooking.productName,
            estimateSla: "-",
            totalTariffAfterDiscount: 0,
            commissionRate: 0,
            bookingCommission: 0,
            isEmbargo: false,
            grossWeight: 0,
            volumeWeight: 0,
            chargeableWeight: 0,
            shippingCost: 0,
            isMasking: true
          })
        );
      }
    } catch (err) {
      this.upsellingData = [];
      this.isErrorUpselling = err?.response?.status >= 500;
      this.formBooking.productName = "";
      this.errorRouteNotFound =
        err.response.data.message.id ===
        "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia";
    } finally {
      this.loadingUpsellingData = false;
    }
  }

  getUpsellingDataDebounced = debounce(async () => {
    if (this.destinationCity.code) {
      await this.getUpsellingData();
    }
  }, 500);

  async fetchDetailPartner() {
    const originResp = (await LocationController.getDetailDistrictByDistrictCode(
      {
        districtCode: this.form.originCity.code
      }
    )) as DistrictData;

    await LocationController.getDetailDistrict({
      id: originResp.id
    });

    const receiverPhone = Array.isArray(this.form.consigneePhone)
      ? this.form.consigneePhone[0].value
      : this.form.consigneePhone;
    this.formBooking = new BookingV3({
      insurance: this.form.insurance,
      sttManual: this.form.sttNumber,
      sttShipmentId: this.form.shipmentId,
      sender: this.form.senderName,
      phoneCodeSender: this.form.sttSenderPhoneCode,
      phoneSender: this.form.senderPhone,
      addressSender: this.form.senderAddress,
      receiver: this.form.consigneeName,
      phoneCodeReceiver: this.form.sttRecipientPhoneCode,
      phoneReceiver: receiverPhone,
      addressReceiver: this.form.consigneeAddress,
      destinationCity: this.form.destinationCity,
      postalCodeDestination: this.form.destinationCity.destinationZipCode,
      addressReceiverType: new OptionsClass({
        name: this.form.addressType,
        value: this.form.addressType
      }),
      commodity: new OptionsClass({
        name: this.form.commodity.commodity_name,
        code: this.form.commodity.commodity_code
      }),
      productName: this.form.product,
      pieces: this.sttPieces,
      estimationPrice: this.defaultStt.sttGoodsEstimatePrice.replace(".", "")
    });

    // komoditas
    const commodities = (await CommodityController.getCommodityList(
      new RequestListCommodity({
        search: "",
        page: 1,
        limit: 1,
        commodityStatus: "active"
      })
    )) as any;

    ((this.$refs as any)
      .commodity as CommoditySection).dataListCommodities = commodities;

    const commodityDetail = (await CommodityController.getCommodityDetail({
      id: this.defaultStt.commodity.commodity_id
    })) as Commodity;

    this.formBooking.commodity = {
      id: commodityDetail.commodity_id,
      name: this.accountIsNonForeign
        ? commodityDetail.commodity_name
        : commodityDetail.commodity_name_en,
      code: commodityDetail.commodity_code,
      status: commodityDetail.commodity_status,
      isDangerousGoods: commodityDetail.isDangerousGoods,
      isQuarantine: commodityDetail.isQuarantine
    } as any;

    const partnerDetail = await PartnerController.fetchPartnerDetail({
      id: this.parentId,
      tieringLevel: false
    });
    if (partnerDetail.partnerIdSttReturn) {
      this.disableSelectPartnerField = !!partnerDetail.partnerIdSttReturn;
      this.selectedPartnerPos = {
        id: partnerDetail.partnerIdSttReturn,
        name: partnerDetail.partnerNameSttReturn
      };
    } else {
      this.disableSelectPartnerField = !!this.posIDForInternal;
      this.selectedPartnerPos = {
        id: this.posIDForInternal,
        name: this.posNameForInternal
      };
    }
    this.form.sttBookedBy = partnerDetail.partnerIdSttReturn;
    await this.populateOrigintData(partnerDetail);
    await this.populateFtz();
  }

  filterPartners = debounce(async (search: string, isSearchBy3LC = false) => {
    this.isLoadingPartners = true;
    const resp = await PartnerController.fetchPartnerApi({
      search: search,
      page: 1,
      limit: 10,
      type: "pos",
      parentId: this.parentId,
      status: "not-banned"
    });
    this.partnersData = resp.filter((key: ClientPartnerOptions) =>
      key.contractStatus.match(/^active|^nearly-expired/gi)
    );
    this.isLoadingPartners = false;
  }, 250);

  onChangePartner = debounce((value: ClientPartnerOptions) => {
    this.selectedPartnerPos = value;
    this.form.sttBookedBy = value.id;
  });

  get sttPieces() {
    return this.form.sttPieces?.map(
      (item: any) =>
        new SttPieces(
          item.pieceId,
          item.grossWeight,
          item.dimension,
          item.volumeWeight,
          item.convertVolumeWeight,
          item.isDimensionDisabled,
          item.errorHws
        )
    ) as any;
  }

  get ftzForm() {
    return new DocInternationalModelValueType({
      email: this.form.sttFtzRecipientEmail,
      idNumber: this.form.sttFtzIdentityNumber,
      imageAfterPackingUrl: this.form.sttFtzAttachFiles[0] || "",
      imageBeforePackingUrl: this.form.sttFtzAttachFiles[1] || "",
      imageIdUrl: this.form.sttFtzKtpImage,
      imageTaxUrl: this.form.sttFtzTaxImage,
      listCommodityCIPL: [new CommodityCIPL()],
      taxNumber: this.form.taxNumber,
      shipmentStatus: new OptionsClass({
        value: this.form.goodsStatus as string
      }),
      dutyTaxTerms: "DAP"
    });
  }

  get isInterpack() {
    return (
      this.form.sttIsInterpack &&
      (!this.form.postalCode || this.form.postalCode.length > 6)
    );
  }

  get validateFtz() {
    return (
      this.form.isFtz &&
      (!String(this.form.sttPiecePerPack).match(/^\d+$/) ||
        !String(this.form.sttNextCommodity).length)
    );
  }

  get validateTaxNumber() {
    return this.form.taxNumber && this.form.taxNumber.length < 20;
  }

  get validatePosField() {
    return !this.posField && (!this.form.product || !this.form.commodity);
  }

  get disabledSubmit() {
    const form = this.formBooking;

    const isEmptyFields = [
      form.sender,
      form.phoneSender,
      form.phoneCodeSender,
      form.addressSender,
      form.receiver,
      form.phoneReceiver,
      form.phoneCodeReceiver,
      form.addressReceiver,
      form.commodity.code,
      form.productName
    ].some((field) => !field);

    return isEmptyFields || (this.posField && !this.selectedPartnerPos);
  }

  async onSubmitEdit() {
    // send data
    this.setForm();
    await this.$nextTick();
    await this.getEstimationPriceDebounce();
    this.closeModal();
    this.form.isNewForm = true;
    this.$emit("onSubmit", this.form);
    CustomProcessController.setIsEditAddress(true);
    this.onSubmitPatchReverseDestination();
  }

  async onSubmitPatchReverseDestination() {
    if (this.form.statusStt === "MISBOOKING") {
      CustomProcessController.setUnableProccessMisbooking(false);
      const receiverPhone = Array.isArray(this.form.consigneePhone)
        ? this.form.consigneePhone[0].value
        : this.form.consigneePhone;
      const payloadReverse = new RequestPatchReverseDestination({
        checkLastBalance: this.lastBalance,
        totalTariff: this.dataDetail.totalTariff,
        bookedBy: this.bookedBy,
        remarks: this.getRemarks,
        sttProductType: this.sttProductType,
        returnCityCode: this.getReturnCityCode,
        returnDistrictCode: this.getReturnDistrictCode,
        returnDistrictName: this.getReturnDistrictName,
        returnReceiptAddress: this.form.consigneeAddress,
        returnReceiptAddressType: this.form.addressType,
        returnReceiptName: this.form.consigneeName,
        returnReceiptPhone: receiverPhone,
        sttDestinationZipCode:
          this.form.destinationCity?.destinationZipCode || "",
        sttCommodityCode: this.form.commodity?.commodity_code || "",
        sttGoodsStatus: this.form.goodsStatus,
        sttTaxNumber: this.form.taxNumber
      });
      const resp = await CustomProcessController.onPatchReverseDestination({
        id: this.shipmentDetail.sttId,
        payload: new PatchReverseDestinationApiRequest({
          payload: payloadReverse
        })
      });
      CustomProcessController.setReverseDestination(payloadReverse);
      if (!resp.success && resp.response) {
        this.handleError(resp);
      }
    }
  }

  async onSave() {
    const resp = await this.getEstimationPriceDebounce();
    if (resp) this.$emit("onSubmit");
  }

  handleError(data: ResponseData) {
    const messageText = resolveApiBilingualMessage(
      data.response.data?.message as
        | { id?: string; en?: string }
        | string
        | undefined
    );
    const lower = messageText.toLowerCase();
    const isPosMinus =
      lower.includes("pos untuk top up saldo") || lower.includes("top up");
    CustomProcessController.setUnableProccessMisbooking(true);
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "image-modal-failed",
        title: String(
          i18n.global.t(
            isPosMinus
              ? "parsingErrorSpec.posBalanceHeader"
              : "parsingErrorSpec.updateFailedHeader"
          )
        ),
        message: messageText,
        textSuccess: String(i18n.global.t("parsingErrorSpec.okUnderstand")),
        onSubmit: () => MainAppController.closeMessageModal()
      })
    );
  }

  get estimationPricePayload() {
    return new GetEstimationPrice({
      originId: this.districtDetail.code,
      destinationId: this.destinationCity.code,
      commodityId: this.formBooking.commodity.id,
      productType: this.formBooking.productName,
      accountType: "pos",
      accountRefId: 0,
      goodsPrice: +this.formBooking.estimationPrice.replaceAll(".", ""),
      insuranceType: this.formBooking.insurance,
      isWoodpacking: this.formBooking.woodpacking,
      isHaveTaxId: !!this.formBooking.ftzForm.taxNumber,
      pieces: this.formBooking.pieces?.map((piece: any) => ({
        pieceLength: piece.dimension.length,
        pieceWidth: piece.dimension.width,
        pieceHeight: piece.dimension.height,
        pieceGrossWeight: +piece.grossWeight
      })) as any,
      isCod:
        this.formBooking.serviceType === "cod" ||
        this.formBooking.serviceType === "dfod",
      isDfod: this.formBooking.serviceType === "dfod",
      codHandling: "",
      codAmount: +this.formBooking.estimationPrice.replaceAll(".", ""),
      isDisablePromo: true,
      promoAppliedTo: "retail",
      isPad: false,
      shipmentPrefix: "",
      hideError: false,
      discountFavoritePercentage: 0
    });
  }

  getEstimationPriceDebounce = debounce(async () => {
    if (
      !this.formBooking.commodity.id ||
      !this.formBooking.estimationPrice ||
      !this.destinationCity.code
    )
      return;
    try {
      this.loadingEstimationPrice = true;
      this.errorEstimationPrice = false;
      const resp = (await BookingController.getEstimationPriceForNewBooking(
        this.estimationPricePayload
      )) as EstimationPrice;
      this.estimationPriceData = resp;
    } catch (err) {
      if (err?.response?.status >= 500) {
        this.errorEstimationPrice = true;
      }
    } finally {
      this.loadingEstimationPrice = false;
    }
  }, 500);

  get districtDetail() {
    return LocationController.districtDetail;
  }

  get getRemarks() {
    return this.remarksMisbooking || "";
  }

  get getReturnDistrictCode() {
    return this.form.destinationCity?.code || "";
  }

  get getReturnDistrictName() {
    return this.form.destinationCity?.name || "";
  }

  get getReturnCityCode() {
    return this.form.destinationCity?.cityCode || "";
  }

  get sttProductType() {
    return typeof this.form.product === "object"
      ? this.form.product?.name
      : this.form.product;
  }

  get bookedBy() {
    return this.remarksMisbooking.includes("POS")
      ? this.shipmentDetail.sttBookedById
      : 0;
  }

  get lastBalance() {
    return this.remarksMisbooking.includes("POS") ? true : false;
  }

  get remarksMisbooking() {
    return CustomProcessController.remarksMisbooking;
  }

  get shipmentDetail() {
    return CustomProcessController.shipmentDetail;
  }

  get dataDetail() {
    return BookingController.estimationPrice;
  }

  async populateOrigintData(partnerDetail: PartnerDetail) {
    // RTS or CNX
    let originDistrict = this.defaultStt.originCity.code;
    if (this.rtsOrCnx) {
      const phoneCode = codePhoneCountry(partnerDetail.partnerPhoneNumber).code;
      const phoneNumber = codePhoneCountry(partnerDetail.partnerPhoneNumber).number;
      this.formBooking.sender = partnerDetail.partnerName;
      this.formBooking.phoneSender = phoneNumber;
      this.formBooking.phoneCodeSender = phoneCode;
      this.formBooking.addressSender = partnerDetail.partnerAddress;
    }
    originDistrict = partnerDetail.partnerDistrictCode;

    if (!this.defaultStt.destinationCity.name) return;

    const destinationDistrict = await LocationController.getDistrictList({
      limit: 40,
      page: 1,
      search: this.defaultStt.destinationCity.name,
      status: "active",
      cache: true,
      excludeCountry: ""
    });

    LocationController.districtData.districtData = destinationDistrict
      .filter((key) => key.status.toLowerCase() === "active")
      .map(
        (e) =>
          new DistrictData({
            ...e,
            name: `${e.name}, ${e.cityName}`
          })
      );

    await this.$nextTick();

    const detailReceiverRef = (this.$refs as any)[
      "detail-receiver"
    ] as DetailReceiver;

    // penerima ambil dari pengirim stt origin
    this.formBooking.addressReceiverType = new OptionsClass({
      value: this.defaultStt.addressType
    });
    const destination = (await LocationController.getDetailDistrictByDistrictCode(
      {
        districtCode: this.defaultStt.destinationCity.code
      }
    )) as DistrictData;
    detailReceiverRef.dataListDistrict = [destination];
    this.formBooking.destinationCity = destination;
    const origin = (await LocationController.getDetailDistrictByDistrictCode({
      districtCode: originDistrict
    })) as DistrictData;
    LocationController.setDetailDistrict(origin);
    await this.$nextTick();
    await detailReceiverRef.onSelectDestinationCity();
    if (this.defaultStt.statusStt === "REROUTE" && this.defaultStt.postalCode)
      this.formBooking.postalCodeDestination = this.defaultStt.postalCode;
    this.sdnReady = true;
  }

  async populateFtz() {
    if (this.defaultStt.sttFtzCipl.length) {
      this.formBooking.ftzForm.listCommodityCIPL = this.defaultStt.sttFtzCipl.map(
        (cipl: any) => {
          return new CommodityCIPL({
            id: new Date().getTime() + Math.random(),
            commodity: {
              name: this.accountIsNonForeign
                ? cipl.item_detail || cipl.itemDetail
                : cipl.item_detail_en || cipl.itemDetailEn,
              nameId: cipl.item_detail || cipl.itemDetail,
              nameEn: cipl.item_detail_en || cipl.itemDetailEn,
              code: cipl.item_detail || cipl.item_detail
            } as any,
            goodsPrice: this.formatCIPLGoodsPrice(
              cipl.item_price || cipl.itemPrice
            ),
            name: cipl.item_detail || cipl.itemDetail,
            quantity: cipl.quantity.toString()
          });
        }
      );
    }
    this.formBooking.ftzForm.email = this.defaultStt.sttFtzRecipientEmail;
    this.formBooking.ftzForm.idNumber = this.defaultStt.sttFtzIdentityNumber;
    this.formBooking.ftzForm.taxNumber = this.defaultStt.sttTaxNumber;
    this.formBooking.ftzForm.imageIdUrl = this.defaultStt.sttFtzKtpImage;
    this.formBooking.ftzForm.imageTaxUrl = this.defaultStt.sttFtzTaxImage;
    this.formBooking.ftzForm.imageBeforePackingUrl =
      this.defaultStt.sttFtzAttachFiles[0] || "";
    this.formBooking.ftzForm.imageAfterPackingUrl =
      this.defaultStt.sttFtzAttachFiles[1] || "";
    this.formBooking.clientName.isFtz = this.defaultStt.isFtz;
    this.error.listCommodityCIPLDocInternational = [];
    this.formBooking.ftzForm.listCommodityCIPL.forEach(() => {
      this.error.listCommodityCIPLDocInternational.push(["", "", ""]);
    });
    await this.$nextTick();

    if (!this.defaultStt.sttSenderStatus || !this.isFtzAccount) return;

    if (this.accountIsNonForeign) {
      this.formBooking.ftzForm.shipmentStatus = (this
        .$refs as any).ftz.shipmentStatusOptions.find(
        (status: OptionsClass) =>
          status.value === this.defaultStt.sttSenderStatus
      );
    } else {
      this.formBooking.ftzForm.shipmentStatus = (this
        .$refs as any).ftz.shipmentStatusInterpackOptions.find(
        (status: OptionsClass) =>
          status.value === this.defaultStt.sttSenderStatus
      );
    }
  }

  formatCIPLGoodsPrice(value = 0) {
    return this.accountIsNonForeign
      ? formatInputMoney(value.toString().replace(/[\D]+/g, ""))
      : formatInputMoneyWithDecimal(value);
  }

  get isErrorEmbargoDestination() {
    return (
      this.upsellingData.length > 0 &&
      this.upsellingData.every((item) => item.isEmbargo) &&
      !!this.formBooking.destinationCity
    );
  }
}
export default ModalBookingReverseJourney;
